import * as React from 'react';
import classnames from 'classnames';

import { __t, applyTranslations } from 'utils/language';

import './help-video-list.scss';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import type { VideoTutorialEntry } from '../../types/VideoTutorialEntry.type';

applyTranslations(require('./help-video-list.i18n.json'));

type Props = {
  pageVideos: Array<VideoTutorialEntry>,
  restVideos: Array<VideoTutorialEntry>,
  videosToBeWatched: Array<string>,
  activeVideoId: string,
  onVideoClick: (a: string) => void
};

class HelpVideoList extends React.PureComponent<Props> {
  renderSectionTitle(title: string): React.ReactNode {
    return (
      <div className="help-video-list__section-title">
        {title}
      </div>
    );
  }

  renderIcon(isHighlighted: boolean, isWatched: boolean): React.ReactNode {
    if (isHighlighted && !isWatched) {
      return (
        <SVGDynamicIcon
          name="play-button-custom-bg"
          width={16}
          height={16}
          customColor="blue"
        />
      );
    }

    return (
      <SVGDynamicIcon
        name="play-button-custom-fg"
        width={16}
        height={16}
        customColor={(isHighlighted) ? 'blue' : 'black'}
      />
    );
  }

  renderVideoEntry(entryName: string, videoId: string, type: string, isHighlighted: boolean): React.ReactNode {
    const { videosToBeWatched, onVideoClick, activeVideoId } = this.props;

    const classNames = classnames('help-video-list__video-entry', {
      'help-video-list__video-entry--highlighted': activeVideoId === videoId
    });

    const wasWatched = !videosToBeWatched.includes(type);

    return (
      <div
        className={classNames}
        key={`tutorial-video-${videoId}`}
        onClick={() => onVideoClick(videoId)}
      >
        <div className="help-video-list__video-entry-icon">
          {this.renderIcon(isHighlighted, wasWatched)}
        </div>
        <span className="help-video-list__video-entry-title">
          {entryName}
        </span>
      </div>
    );
  }

  renderWithActiveList(): React.ReactNode {
    const { pageVideos, restVideos } = this.props;

    return (
      <React.Fragment>
        {this.renderSectionTitle(__t('help_video_list.video_current_page'))}
        {
          pageVideos.map(entry => this.renderVideoEntry(entry.name, entry.id, entry.kind, true))
        }
        {this.renderSectionTitle(__t('help_video_list.video_other_pages'))}
        {
          restVideos.map(entry => this.renderVideoEntry(entry.name, entry.id, entry.kind, false))
        }
      </React.Fragment>
    );
  }

  renderAllVideos(): React.ReactNode {
    const { restVideos } = this.props;

    return (
      <React.Fragment>
        {this.renderSectionTitle(__t('help_video_list.video_overall'))}
        {
          restVideos.map(entry => this.renderVideoEntry(entry.name, entry.id, entry.kind, false))
        }
      </React.Fragment>
    );
  }

  render(): React.ReactNode {
    const { pageVideos } = this.props;
    const hasPageVideos = pageVideos.length > 0;

    return (
      <div
        key={`list-reset-scroll-on-rerender-${Math.random()}`}
        className="help-video-list"
      >
        {!hasPageVideos && this.renderAllVideos()}
        {hasPageVideos && this.renderWithActiveList()}
      </div>
    );
  }
}

export default HelpVideoList;
